export default "__VITE_ASSET__XsZmYI3m__"